import React, { useState } from 'react';
import styled from 'styled-components';

const IAOfficersEdit = ({ darkMode, data, onClose }) => {
  const [formData, setFormData] = useState({
    last_name: data.last_name || '',
    first_name: data.first_name || '',
    middle_name: data.middle_name || '',
    phone_number: data.phone_number || '',
    email: data.email || '',
    address: data.address || '',
    date_of_birth: data.date_of_birth || '',
    name_of_spouse: data.name_of_spouse || '',
    position: data.position || '',
    appointment_year: data.appointment_year || '',
    tin: data.tin || '',
    motto: data.motto || '',
    photo: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, photo: file });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    onClose();
  };

  return (
    <FormContainer darkMode={darkMode}>
      <FormHeader>
        <FormTitle>Edit Officer</FormTitle>
        <CloseButton onClick={onClose}>×</CloseButton>
      </FormHeader>
      <Form onClick={(e) => e.stopPropagation()}>
        <PhotoUpload>
          <PhotoPlaceholder>
            {formData.photo ? (
              <img src={URL.createObjectURL(formData.photo)} alt="Officer" />
            ) : (
              <PlaceholderText>Upload Photo</PlaceholderText>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={handlePhotoChange}
              style={{ display: 'none' }}
              id="photo-upload"
            />
          </PhotoPlaceholder>
          <UploadButton as="label" htmlFor="photo-upload">
            Choose Photo
          </UploadButton>
        </PhotoUpload>
        <InputGroup>
          <Label>Last Name</Label>
          <Input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            required
          />
        </InputGroup>
        <InputGroup>
          <Label>First Name</Label>
          <Input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            required
          />
        </InputGroup>
        <InputGroup>
          <Label>Middle Name</Label>
          <Input
            type="text"
            name="middle_name"
            value={formData.middle_name}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Phone Number</Label>
          <Input
            type="tel"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Email</Label>
          <Input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Address</Label>
          <Input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Date of Birth (mm/dd/yy)</Label>
          <Input
            type="text"
            name="date_of_birth"
            value={formData.date_of_birth}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Name of Spouse</Label>
          <Input
            type="text"
            name="name_of_spouse"
            value={formData.name_of_spouse}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Position</Label>
          <Input
            type="text"
            name="position"
            value={formData.position}
            onChange={handleChange}
            required
          />
        </InputGroup>
        <InputGroup>
          <Label>Appointment Year</Label>
          <Input
            type="text"
            name="appointment_year"
            value={formData.appointment_year}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>TIN</Label>
          <Input
            type="text"
            name="tin"
            value={formData.tin}
            onChange={handleChange}
          />
        </InputGroup>
        <InputGroup>
          <Label>Motto</Label>
          <Input
            type="text"
            name="motto"
            value={formData.motto}
            onChange={handleChange}
          />
        </InputGroup>
        <SubmitButton type="submit" onClick={handleSubmit}>
          Update Officer
        </SubmitButton>
      </Form>
    </FormContainer>
  );
};

export default IAOfficersEdit;

const FormContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? '#2a2a2a' : '#ffffff')};
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  padding: 20px;
  z-index: 1000;
  overflow-y: auto;
`;

const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const FormTitle = styled.h3`
  font-size: 18px;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const PhotoUpload = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const PhotoPlaceholder = styled.div`
  width: 150px;
  height: 150px;
  border: 2px dashed ${({ darkMode }) => (darkMode ? '#ffffff' : '#cccccc')};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PlaceholderText = styled.span`
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#666666')};
  font-size: 14px;
`;

const UploadButton = styled.button`
  padding: 6px 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #388e3c;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 14px;
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
  margin-bottom: 5px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: ${({ darkMode }) => (darkMode ? '#333333' : '#ffffff')};
  color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333333')};
`;

const SubmitButton = styled.button`
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    background-color: #388e3c;
  }
`;